const CONFIG = {
    publishKey: window.hearo_pubnubPubKey,
    subscribeKey: window.hearo_pubnubSubKey,
}

export default {
    CONFIG: CONFIG
}